<app-navbar></app-navbar>

<section class="blog-area ptb-100">
  <div class="container">
    <h3 class="widget-title" style="color: #ffffff; text-align: center">
      Signing Ceremony with Trust Axiata Pay (TAP)
    </h3>
    <hr />
    <div>
      <p style="color: white;">
        Proyash-Chattogram had a signing agreement with Trust Axiata Pay (TAP)
        to ease the payment and accounting system.
      </p>
      <section class="blog-area gallery-section">
        <div class="container">
          <div class="container">
            <div class="gallery-container">
              <div class="gallery">
                <a
                  *ngFor="let image of images"
                  class="gallery__item"
                  href="{{ image.src }}"
                  [title]="image.alt"
                >
                  <img
                    [src]="image.thumbnail"
                    [alt]="image.alt"
                    class="popup-btn"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>
